import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

const selectRooms = createSelector(
  (state: RootState) => state.roomsState,
  (state) => state.paginatedRoomsInfo?.data,
);

const selectPaginationInfo = createSelector(
  (state: RootState) => state.roomsState,
  (state) => state.paginatedRoomsInfo?.paginationInfo,
);

const selectCurrentRoom = createSelector(
  (state: RootState) => state.roomsState,
  (state) => state.currentRoom,
);

const selectIsLoadingRooms = createSelector(
  (state: RootState) => state.roomsState,
  (state) => state.isLoadingRooms,
);

const selectIsLoadingRoom = createSelector(
  (state: RootState) => state.roomsState,
  (state) => state.isLoadingRoom,
);

export const roomsSelectors = {
  selectRooms,
  selectPaginationInfo,
  selectCurrentRoom,
  selectIsLoadingRooms,
  selectIsLoadingRoom,
};
